module.exports = require('./lib/chai');



//////////////////
// WEBPACK FOOTER
// ./~/chai/index.js
// module id = 2182
// module chunks = 0 1